import { createContext, useContext, useState, useEffect } from 'react';

const LIGHT = {
  bg:"#FFFFFF", surface:"#f4f4f5", surfaceAlpha:"rgba(0,47,167,0.025)",
  border:"rgba(9,9,11,0.09)", borderSolid:"#e4e4e7",
  text:"#09090b", textSecondary:"#3f3f46", muted:"#52525b", dim:"#a1a1aa",
  white:"#09090b", cardText:"#09090b",
  cardBg:"#ffffff", tooltipBg:"#ffffff", tooltipBorder:"rgba(0,47,167,0.14)",
  navBg:"rgba(255,255,255,0.92)", tickerBg:"#f4f4f5",
  gridLine:"rgba(9,9,11,0.06)", axisTick:"#52525b",
  modalBg:"#ffffff", modalOverlay:"rgba(9,9,11,0.5)",
  codeBg:"#f4f4f5", hoverBg:"rgba(0,47,167,0.05)",
  scrollThumb:"#d4d4d8", scrollTrack:"#fafafa",
  brandBar:"rgba(0,47,167,0.02)", funnelText:"rgba(9,9,11,.7)",
  primary:"#002FA7", accent:"#00D4FF",
  elev1:"0 1px 2px rgba(0,47,167,0.05), 0 1px 3px rgba(0,47,167,0.06)",
  elev2:"0 2px 4px rgba(0,47,167,0.06), 0 8px 20px -4px rgba(0,47,167,0.10)",
  elev3:"0 8px 16px rgba(0,47,167,0.08), 0 24px 56px -12px rgba(0,47,167,0.20)",
};

const DARK = {
  bg:"#09090b", surface:"#18181b", surfaceAlpha:"rgba(255,255,255,.032)",
  border:"rgba(255,255,255,.09)", borderSolid:"#27272a",
  text:"#fafafa", textSecondary:"#d4d4d8", muted:"#a1a1aa", dim:"#71717a",
  white:"#fff", cardText:"#fff",
  cardBg:"#18181b", tooltipBg:"#18181b", tooltipBorder:"rgba(255,255,255,0.12)",
  navBg:"rgba(9,9,11,.96)", tickerBg:"#111113",
  gridLine:"rgba(255,255,255,.07)", axisTick:"#a1a1aa",
  modalBg:"#18181b", modalOverlay:"rgba(0,0,0,0.75)",
  codeBg:"#09090b", hoverBg:"rgba(51,119,255,.10)",
  scrollThumb:"#27272a", scrollTrack:"#09090b",
  brandBar:"rgba(255,255,255,.03)", funnelText:"rgba(9,9,11,.85)",
  primary:"#3377FF", accent:"#00D4FF",
  elev1:"0 1px 2px rgba(0,0,0,0.5), 0 1px 3px rgba(0,20,60,0.4)",
  elev2:"0 2px 6px rgba(0,0,0,0.5), 0 10px 24px -4px rgba(0,30,90,0.35)",
  elev3:"0 10px 20px rgba(0,0,0,0.55), 0 28px 64px -12px rgba(0,40,120,0.45)",
};

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('omni-theme') || 'light');

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('omni-theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'light' ? 'dark' : 'light');

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, colors: theme === 'dark' ? DARK : LIGHT, isDark: theme === 'dark' }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
